import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  // Navigate,
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Headers
import DashboardHeader from "./components/DashboardHeader/DashboardHeader";
import StudentSidebar from "./components/Student/StudentSidebar/StudentSidebar";

// Guards
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import TutorRouteGuard from "./components/ProtectedRoute/TutorRouteGuard";

// Pages
import GetStart from "./components/GetStart/GetStart";
import ChooseRole from "./components/ChooseRole/ChooseRole";

// Admin login
import AdminSignin from "./components/Admin/AdminSignin/AdminSignin";

// Student and Tutor login's
import SignIn from "./components/SignIn/SignIn";
import SignUp from "./components/SignUp/SignUp";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";

// Tutor Onboarding
import TutorOnboarding from "./components/Tutor/TutorOnboarding/TutorOnboarding";
import TutorDashboardUnderReview from "./components/Tutor/TutorDashboardUnderReview/TutorDashboardUnderReview";

// Final assignment
import StudentFinalAssignment from "./components/Student/StudentFinalAssignment/StudentFinalAssignment";

// Routes
import PublicRoutes from "./routes/PublicRoutes";
import StudentRoutes from "./routes/StudentRoutes";
import TutorRoutes from "./routes/TutorRoutes";
import AdminRoutes from "./routes/AdminRoutes";

const App = () => (
  <Router>
    <ScrollToTop />
    <ToastContainer />

    <Routes>
      <Route path="/*" element={<PublicRoutes />} />
      <Route path="/get-start" element={<GetStart />} />
      <Route path="/choose-role" element={<ChooseRole />} />

      {/* Admin login */}
      <Route path="/admin-signin" element={<AdminSignin />} />

      {/* Student & Tutor Routes login's */}
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* Tutor & Admin  Dashboard Header */}
      <Route path="/header/*" element={<DashboardHeader />}>
        {/* Tutor Pages */}
        <Route
          path="tutor/*"
          element={
            <ProtectedRoute allowedRoles={["tutor"]}>
              <TutorRoutes />
            </ProtectedRoute>
          }
        />

        {/* Admin Pages */}
        <Route
          path="admin/*"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminRoutes />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* Student Dashboard with Sidebar */}
      <Route
        path="/student/*"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <StudentSidebar />
          </ProtectedRoute>
        }
      >
        {/* Student Pages */}
        <Route
          path="*"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentRoutes />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* Student Final Assignment Route (outside sidebar) */}
      <Route
        path="/student/final-assignment/:finalAssignmentId"
        element={
          <ProtectedRoute allowedRoles={["student"]}>
            <StudentFinalAssignment />
          </ProtectedRoute>
        }
      />

      {/* Tutor Onboarding Routes*/}
      <Route
        path="/tutor-onboarding"
        element={
          <ProtectedRoute allowedRoles={["tutor"]}>
            <TutorRouteGuard>
              <TutorOnboarding />
            </TutorRouteGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tutor-dashboard-under-review"
        element={
          <ProtectedRoute allowedRoles={["tutor"]}>
            <TutorRouteGuard>
              <TutorDashboardUnderReview />
            </TutorRouteGuard>
          </ProtectedRoute>
        }
      />
    </Routes>
  </Router>
);

export default App;
